import React from "react";
import Settings from "../components/Settings/Settings";
export default function SettingsPage() {
  return (
    <div className="page-layout">
      <Settings />
    </div>
  );
}
